import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { SadtStatusEnum } from '../../enum/sadt-status.enum';
import { SadtGroupStruct } from '../../services/structs/medical-record/sadt-group.struct';

@Component({
    selector: 'app-exams-suspension-cofirm-modal',
    templateUrl: './exams-suspension-cofirm-modal.component.html',
    styleUrls: ['./exams-suspension-cofirm-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExamsSuspensionCofirmModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<ExamsSuspensionCofirmModalComponent>,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
  ) { }

  public sadtStatusEnum: typeof SadtStatusEnum = SadtStatusEnum;

  public isLoading: boolean = true;

  public model: FormGroup;
  public examToSuspend: SadtGroupStruct;

  ngOnInit(): void {
    if(this.data){
      this.examToSuspend = {...this.data.examToSuspend};
    }

    this.model = this.formBuilder.group({
      motiveSuspended: ["", [Validators.required]]
    });

    this.isLoading = false;
  }

  close() {
    this.matDialogRef.close({
      examToSuspend: this.examToSuspend,
    });
  }

  cancel() {
    this.examToSuspend = null;
    this.close();
  }

  submit() {
    if(this.isLoading)
      return;
    
    this.isLoading = true;
    if (this.model.invalid) {
      this.alertService.show('Erro', "Preencha todos os campos em vermelho!", AlertType.error);
      this.isLoading = false;
      return;
    }
    
    this.examToSuspend.idStatus = this.sadtStatusEnum.Suspenso;
    this.examToSuspend.motiveSuspended = this.model.get('motiveSuspended').value;
    this.close();
    
  }

}
